import React from 'react';
import TsMuteButton from '../dashboard/ts-mute-button/ts-mute-button.component';
import './ts-dashboard-title.style.scss';
import {getRootStore} from '../../app.bootstrap';
import {DashboardState} from '../../states/dashboard/_contracts/DashboardState';
import {observer} from 'mobx-react';

export interface TsDashboardTitleProps {
    dashboardState: DashboardState;
    handleAction: (event: React.MouseEvent) => void;
    showMuteButton: boolean;
    toggleMute: (event: React.MouseEvent) => void;
}

const TsDashboardTitleComponent: React.FC<TsDashboardTitleProps> = ({
    dashboardState,
    handleAction,
    showMuteButton,
    toggleMute
}) => {
    const translate = getRootStore().localizationService.translate;

    const getTitleString = () => {
        const t = translate;

        const titles = [
            {
                string: t('MAIN.VIEW.MODE_LIVE_VIDEO'),
                value: dashboardState.isLiveVideo && !dashboardState.videoModeState.videoState.isPaused
            },
            {
                string: t('MAIN.VIEW.MODE_LIVE_VIDEO_RESUME'),
                value:
                    dashboardState.isLiveVideo &&
                    dashboardState.videoModeState.videoState.isPaused &&
                    dashboardState.videoModeState.videoState.videoPausedByDashboard
            },
            {
                string: t('MAIN.VIEW.MODE_LIVE_PAUSED_BY_CUSTOMER'),
                value:
                    dashboardState.isLiveVideo &&
                    dashboardState.videoModeState.videoState.isPaused &&
                    !dashboardState.videoModeState.videoState.videoPausedByDashboard
            },
            {string: t('MAIN.VIEW.MODE_SCANNING'), value: dashboardState.isScanMode},
            {string: t('MOBILE_MAIN.VIEW.PHOTO_MODE'), value: dashboardState.isPhotoTitle},
            {string: t('MAIN.VIEW.MODE_EDIT'), value: dashboardState.isCanvas && !dashboardState.offlineMode},
            {string: t('MAIN.VIEW.MODE_SCREEN_SHARING'), value: dashboardState.isScreenSharing},
            {string: t('MAIN.VIEW.MODE_APPLICATION_SHARING'), value: dashboardState.isApplicationSharing},
            {string: t('MAIN.VIEW.MODE_DESKTOP_SHARING'), value: dashboardState.isDesktopSharing},
            {string: t('MAIN.VIEW.MODE_LIVE_VIDEO'), value: dashboardState.isVideoApplication}
        ].filter((title) => title.value);

        return titles[0]?.string ?? '';
    };

    const titleString = getTitleString();

    if (!titleString) {
        return <React.Fragment />;
    }

    const containerClasses = [
        'dashboard-title',
        dashboardState.isTitleActionHidden ? 'no-actions' : '',
        dashboardState.isPhotoTitle ? 'photo-title' : '',
        dashboardState.extraStyle ? 'extra-style' : ''
    ]
        .filter(Boolean)
        .join(' ');

    const actionClassName = [
        'dashboard-title-action',
        dashboardState.actionClasses.live ? 'live' : '',
        dashboardState.actionClasses.scan ? 'scan' : '',
        dashboardState.actionClasses.canvas ? 'canvas' : '',
        dashboardState.actionClasses.paused ? 'paused' : ''
    ]
        .filter(Boolean)
        .join(' ');

    const titleTextClasses = [
        'dashboard-title-text',
        showMuteButton && dashboardState?.useNewInterface ? 'audio-button' : ''
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={containerClasses}>
            {showMuteButton ? (
                <div className='dashboard-title-action mute-button'>
                    <TsMuteButton
                        useNewInterface={dashboardState.useNewInterface}
                        isMicrophoneMuted={dashboardState.videoModeState.isMicrophoneMuted}
                        isSupportAudio={dashboardState.videoModeState.isSupportAudio}
                        toggleMute={toggleMute}
                    />
                </div>
            ) : null}

            <div className={titleTextClasses}>
                <div>{titleString}</div>
            </div>

            {!dashboardState.isTitleActionHidden && !dashboardState.isPhotoTitle ? (
                <div className={actionClassName} onClick={handleAction} />
            ) : (
                <></>
            )}
        </div>
    );
};

export const TsDashboardTitle = observer(TsDashboardTitleComponent);
